module.exports = __webpack_public_path__ + "static/media/page18_kopila.65d4d318.png";